const MediaTypeMap = {
    POSTER: "0",
    VIDEO: "1",
    PDF: "2"
};


module.exports = {
    MediaTypeMap
};